import React from 'react';
import { graphql } from 'react-apollo';
import { Dropdown } from 'semantic-ui-react';

import { AllSettlementTypes } from '../../queries/AllSettlementTypes';
import Field from '../Field';

const SettlementTypesDropdown = ({ data, label, error, touched, ...rest }) => {
  const { allSettlementTypes = [], loading = false } = data || {};
  const settlementTypesOptions = allSettlementTypes.map(type => ({
    key: type,
    value: type,
    text: type
  }));
  return (
    <Field error={error} touched={touched}>
      <label>{label}</label>
      <Dropdown
        fluid
        selection
        search
        options={settlementTypesOptions}
        loading={loading}
        {...rest}
      />
    </Field>
  );
};

export default graphql(AllSettlementTypes, {
  skip: ({ disabled }) => disabled,
  options: props => ({ fetchPolicy: 'cache-first' })
})(SettlementTypesDropdown);



// WEBPACK FOOTER //
// ./src/component/dropdowns/SettlementTypesDropdown.js